import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage/storage.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Component({
	selector: 'app-prospect-operations',
	templateUrl: './prospect-operations.component.html',
	styleUrls: ['./prospect-operations.component.scss']
})
export class ProspectOperationsComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() page_data: any;
	@Input() page_operation_type: any;

	@Output() prospectOperationsClosed = new EventEmitter<any>();
	@Output() prospectOperationsUpdated = new EventEmitter<any>();

	current_date: any = new Date();
	user_details: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
		public datePipe: DatePipe,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		this.getGenders();
		this.getStatus();
		this.getStates();
		this.getRegion();
		this.getDataTypeList();
		this.getBusinessPlan();

		setTimeout(() => {
			this.openClientOperationModal();
		}, 200);
	}

	region_list: any = [];
	getRegion() {
		const financial_institution = this.user_details.financial_institution;

		this.commonService.getData('/region?no_page=true&financial_institution=' + financial_institution).subscribe(
			(res: any) => {
				this.region_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	genders_list: any = [];
	getGenders() {
		this.commonService.getData('/gender?no_page=true/').subscribe(
			(res: any) => {
				this.genders_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	status_list: any = [];
	getStatus() {
		this.commonService.getData('/clientStatus?no_page=true/').subscribe(
			(res: any) => {
				this.status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	states_list: any = [];
	getStates() {
		this.commonService.getData('/state?no_page=true/').subscribe(
			(res: any) => {
				this.states_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	data_type_list: any = [];
	getDataTypeList() {
		this.commonService.getData('/datatype?no_page=true/').subscribe(
			(res: any) => {
				this.data_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	data_type_values_list: any = [];
	getDataTypeValues(value) {
		if (value == 4) {
			this.data_type_values_list = [];
		} else if (value == 5) {
			this.commonService.getData('/datatypevalue?data_type=' + value + '&no_page=true/',).subscribe(
				(res: any) => {
					this.data_type_values_list = res;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				}
			);
		} else if (value == 6) {
			this.commonService.getData('/financialinstitution?no_page=true/',).subscribe(
				(res: any) => {
					this.data_type_values_list = res;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				}
			);
		} else {
			this.commonService.getData('/datatypevalue?data_type=' + value + '&no_page=true/',).subscribe(
				(res: any) => {
					this.data_type_values_list = res;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				}
			);
		}
	}

	business_plan_list: any = [];
	getBusinessPlan() {
		const financial_institution = this.user_details.financial_institution;
		this.commonService.getData('/businessPlan?no_page=true&financial_institution=' + financial_institution).subscribe(
			(res: any) => {
				this.business_plan_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	@ViewChild('pageOperationsModal') pageOperationsModal: TemplateRef<any>;
  	private pageOperationsModalRef: MatDialogRef<TemplateRef<any>>;
	openClientOperationModal() {
		if (this.page_operation_type == 'Add') {
			this.page_data = JSON.parse(JSON.stringify(this.ideal_page_data));

		} else {
			this.page_data.birth_date = this.datePipe.transform(this.page_data.birth_date, 'MM-dd-yyyy');

			if ( this.page_data.last_date_of_contact != "" &&  this.page_data.last_date_of_contact != null) {
				this.page_data.last_date_of_contact = this.datePipe.transform(this.page_data.last_date_of_contact, 'MM-dd-yyyy');
			}

			this.getDataTypeValues(this.page_data.source_type_id);

		}

		this.pageOperationsModalRef = this.dialog.open(this.pageOperationsModal, { disableClose: true } );
		this.pageOperationsModalRef.afterClosed().subscribe((result) => {
			this.closeClientOperationModal();
		});
	}

	closeClientOperationModal() {
		this.prospectOperationsClosed.emit("Closed");
		this.pageOperationsModalRef.close();
	}

	page_operation_stepper: any = 1;
	navigateBack() {
		this.page_operation_stepper = this.page_operation_stepper - 1;
	}

	product_error: boolean = false;
	validateClientDetails() {
		if (this.page_operation_stepper == 1) {
			const fields = [
				{ key: "source_type_id", type: "text" },
				{ key: "prospect_id", type: "text" },
				{ key: "first_name", type: "text" },
				{ key: "last_name", type: "text" },
				{ key: "email", type: "email" },
				{ key: "birth_date", type: "date" },
				{ key: "individual_income_in_dollars_actual", type: "number" },
				{ key: "state_id", type: "text" },
			];

			if (this.validatePageIndividualSection(fields)) {
				if (this.page_data.source_type_id == 2) {
					if (this.page_data.source != "" && this.page_data.source != null) {
						this.page_data_errors.source = false;
					} else {
						this.page_data_errors.source = true;
					}
					this.page_data_errors.source_id = false;
				} else if (this.page_data.source_type_id != 4) {
					if (this.page_data.source_id != "" && this.page_data.source_id != null) {
						this.page_data_errors.source_id = false;
					} else {
						this.page_data_errors.source_id = true;
					}

					this.page_data_errors.source = false;
				}

				if (
					this.page_data_errors.source == false &&
					this.page_data_errors.source_id == false
				) {
					this.page_operation_stepper = this.page_operation_stepper + 1;
				}
			}

		} else if (this.page_operation_stepper == 2) {
			const fields = [];

			if (this.validatePageIndividualSection(fields)) {
				this.page_operation_stepper = this.page_operation_stepper + 1;
			}
		} else if (this.page_operation_stepper == 3) {
			const fields = [
				// { key: "business_plan_id", type: "text" },
			];

			if (this.validatePageIndividualSection(fields)) {
				this.savePageInformation();
			}
		}
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
	}

	validEmail(email) {
		if (
			email != '' &&
			/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
		) {
			return true;
		} else {
			return false;
		}
	}

	global_error: boolean = false;
	validatePageIndividualSection(fields) {
		if (fields.length > 0) {
			// let error: boolean = false;
			this.global_error = false;
			for (let index = 0; index < fields.length; index++) {
				if (fields[index].type == "text" || fields[index].type == "number" || fields[index].type == "date") {
					if (this.page_data[fields[index]["key"]] != "" && this.page_data[fields[index]["key"]] != null) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				} else if (fields[index].type == "email") {
					if (this.page_data[fields[index]["key"]] != "" && this.page_data[fields[index]["key"]] != null && this.validEmail(this.page_data[fields[index]["key"]])) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				} else if (fields[index].type == "boolean") {
					if (this.page_data[fields[index]["key"]] == true || this.page_data[fields[index]["key"]] == false) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				}
			}

			// if (error == true) {
			// 	return false;
			// } else {
			// 	return true;
			// }

			if (this.global_error == true) {
				return false;
			} else {
				return true;
			}

		} else {
			this.global_error = false
			return true;
		}
	}

	savePageInformation() {
		this.page_data.birth_date = this.datePipe.transform(this.page_data.birth_date, 'yyyy-MM-dd');
		this.page_data.last_date_of_contact = this.datePipe.transform(this.page_data.last_date_of_contact, 'yyyy-MM-dd');

		if (this.page_data.net_worth_actual) {
			this.page_data.net_worth = this.page_data.net_worth_actual;
		}

		if (this.page_data.household_income_in_dollars_actual) {
			this.page_data.household_income_in_dollars = this.page_data.household_income_in_dollars_actual;
		}

		if (this.page_data.market_value_of_home_in_dollars_actual) {
			this.page_data.market_value_of_home_in_dollars = this.page_data.market_value_of_home_in_dollars_actual;
		}

		if (this.page_data.home_equity_available_for_mortgage_in_dollars_actual) {
			this.page_data.home_equity_available_for_mortgage_in_dollars = this.page_data.home_equity_available_for_mortgage_in_dollars_actual;
		}

		if (this.page_data.individual_income_in_dollars_actual) {
			this.page_data.individual_income_in_dollars = this.page_data.individual_income_in_dollars_actual;
		}

		if (this.page_data.total_networth_actual) {
			this.page_data.total_networth = this.page_data.total_networth_actual;
		}

		if (this.page_operation_type == 'Add') {
			this.commonService.postData('/prospect/', this.page_data).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Prospect has been added successfully.');
					this.prospectOperationsUpdated.emit("Added");

					this.pageOperationsModalRef.close();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		} else {
			this.commonService.updateData('/prospect/' + this.page_data.id + '/', this.page_data).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Prospect has been updated successfully.');
					this.prospectOperationsUpdated.emit("Updated");

					this.pageOperationsModalRef.close();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}


	ideal_page_data: any = {
		prospect_id: "",
		first_name: "",
		last_name: "",
		telephone_number: "",
		email: "",
		gender_id: "",
		birth_date: "",
		education: "",
		occupation: "",
		years_experience: "",
		marital_status: "",
		individual_income_in_dollars_actual: "",
		address_line_1: "",
		address_line_2: "",
		city: "",
		state_id: "",
		region_id: "",
		zip_code: "",
		homeowner_or_renter: "",
		years_in_residence: "",
		address_2_line_1: "",
		address_2_line_2: "",
		address_2_city: "",
		address_2_state_id: "",
		address_2_region_id: "",
		address_2_zip_code: "",
		address_2_years_in_residence: "",
		address_2_homeowner_or_renter: "",
		address_3_line_1: "",
		address_3_line_2: "",
		address_3_city: "",
		address_3_state_id: "",
		address_3_region_id: "",
		address_3_zip_code: "",
		address_3_years_in_residence: "",
		address_3_homeowner_or_renter: "",
		household_id: "",
		is_primary_contact: false,
		adults_in_household: "",
		children_in_household: "",
		household_income_in_dollars_actual: "",
		real_estate_investor: false,
		premium_credit_card_holder: false,
		heavy_transactor: "",
		economic_stability: "",
		vehicle_type: "",
		vehicle_count: "",
		property_type: "",
		home_equity_available_for_mortgage_in_dollars_actual: "",
		loan_to_value_in_percentage: "",
		market_value_of_home_in_dollars_actual: "",
		net_worth_actual: "",
		total_networth_actual: "",
		source_type_id: "",
		source_id: "",
		source: "",
		segment: "",
		last_date_of_contact: "",
		business_plan_id: "",
		linkedin_url: "",
		twitter_url: "",
		facebook_url: "",
	};

	page_data_errors: any = {
		prospect_id: false,
		first_name: false,
		last_name: false,
		telephone_number: false,
		email: false,
		gender_id: false,
		birth_date: false,
		education: false,
		occupation: false,
		years_experience: false,
		marital_status: false,
		individual_income_in_dollars_actual: false,
		address_line_1: false,
		address_line_2: false,
		city: false,
		state_id: false,
		region_id: false,
		zip_code: false,
		homeowner_or_renter: false,
		years_in_residence: false,
		address_2_line_1: false,
		address_2_line_2: false,
		address_2_city: false,
		address_2_state_id: false,
		address_2_region_id: false,
		address_2_zip_code: false,
		address_2_years_in_residence: false,
		address_2_homeowner_or_renter: false,
		address_3_line_1: false,
		address_3_line_2: false,
		address_3_city: false,
		address_3_state_id: false,
		address_3_region_id: false,
		address_3_zip_code: false,
		address_3_years_in_residence: false,
		address_3_homeowner_or_renter: false,
		household_id: false,
		is_primary_contact: false,
		adults_in_household: false,
		children_in_household: false,
		household_income_in_dollars_actual: false,
		real_estate_investor: false,
		premium_credit_card_holder: false,
		heavy_transactor: false,
		economic_stability: false,
		vehicle_type: false,
		vehicle_count: false,
		property_type: false,
		home_equity_available_for_mortgage_in_dollars_actual: false,
		loan_to_value_in_percentage: false,
		market_value_of_home_in_dollars_actual: false,
		net_worth_actual: false,
		total_networth_actual: false,
		source_type_id: false,
		source_id: false,
		source: false,
		segment: false,
		last_date_of_contact: false,
		business_plan_id: false,
		linkedin_url: false,
		twitter_url: false,
		facebook_url: false,
	};

	@ViewChild('householdLookupModal') householdLookupModal: TemplateRef<any>;
	private householdLookupModalRef: MatDialogRef<TemplateRef<any>>;
	openHouseholdLookupModal() {
		this.householdLookupModalRef = this.dialog.open(this.householdLookupModal, { disableClose: true });
		this.householdLookupModalRef.afterClosed().subscribe((result) => {
			this.closeHouseholdLookupModal();
		});
	}

	closeHouseholdLookupModal() {
		this.householdLookupModalRef.close();
		this.household_list = [];
		this.household_search_key = "";
	}

	changePrimaryContact() {
		if (this.page_data.is_primary_contact == true) {
			this.generateHouseholdID();
		}
	}



	generated_household_id: any = "";
	generateHouseholdID() {
		// if (this.page_data.household_id == "" || this.page_data.household_id == null) {
		// 	if (this.generated_household_id == "" || this.generated_household_id != null) {
		// 		this.commonService.getData('/generatehouseholdid/').subscribe(
		// 			(res: any) => {
		// 				this.generated_household_id = res;
		// 				this.page_data.household_id = this.generated_household_id;
		// 			},
		// 			(err) => {
		// 				this.commonService.showToast('error', err.error);
		// 			},
		// 		);
		// 	}
		// }

		if (this.page_data.household_id == "" || this.page_data.household_id == null) {
			this.commonService.getData('/generatehouseholdid/').subscribe(
				(res: any) => {
					this.generated_household_id = res;
					this.page_data.household_id = this.generated_household_id;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

	}

	household_search_key: any = "";
	lookUpHouseHold() {
		this.household_search_key = "";
		this.openHouseholdLookupModal();
	}

	household_list: any = [];
	searchHousehold() {
		this.commonService.getData('/gethouseholdid/?search=' + this.household_search_key).subscribe(
			(res: any) => {
				this.household_list = res["data"];
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	copy(data) {
		this.page_data.household_id = data.household_id;
		this.page_data.household_primary_contact_name = data.household_primary_contact_name;
		this.closeHouseholdLookupModal();
	}

}
